import script from "./SupervisionBanner.vue?vue&type=script&lang=ts&setup=true"
export * from "./SupervisionBanner.vue?vue&type=script&lang=ts&setup=true"

import "./SupervisionBanner.vue?vue&type=style&index=0&id=47e18414&scoped=true&lang=css"

import exportComponent from "/home/tecnonet/proyectos/galidancia_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47e18414"]])

export default __exports__